export const parseBenefits = (products = []) => {
  
  const res = products
    .flatMap(p => p.benefits)
    .map(benefit => {
      const selected = benefit.levels.find(l => l.isSelected)
      if (!selected) return null

      return { label: benefit.name, value: selected.description }
    })
    .filter(Boolean)

  return res
}
